export default "__VITE_ASSET__Lo$ZBzOf__"